import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { StatusRegistryProvider, TooltipProvider } from '@shining-technologies/ui';
import { KitToaster } from '@/components/feedback/KitToaster';
import { ADMIN_STATUS_REGISTRY } from '@/app/statusRegistry';
import { queryClient } from '@/lib/queryClient';

/**
 * Global providers (Query, UI-kit status vocabulary, tooltips, toaster). Auth
 * lives inside the router. The kit's `TooltipProvider` wraps the same Radix
 * `Tooltip.Provider` instance the legacy `components/ui/tooltip` uses (deduped
 * by npm), so it also serves pages not yet converted to the kit.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <StatusRegistryProvider registry={ADMIN_STATUS_REGISTRY}>
        <TooltipProvider delayDuration={200}>
          {children}
          <KitToaster />
        </TooltipProvider>
      </StatusRegistryProvider>
    </QueryClientProvider>
  );
}
